import { z } from "zod";

export const DischargeLetterENTFormSchema = z.object({
  additional_diagnostic_findings: z.string().optional(),
  admission_medications: z.string().optional(),
  anamnesis: z.string().optional(),
  clinical_course: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  laboratory_parameters: z.string().optional(),
  parameters: z.string().optional(),
  recommendations: z.string().optional(),
  therapy: z.string().optional(),
});
